import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

import { SharedButtonsModule } from '@shared/buttons';

@Component({
  selector: 'la-error-state-card',
  templateUrl: './error-state-card.component.html',
  styleUrls: ['./error-state-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, MatButtonModule, SharedButtonsModule],
})
export class ErrorStateCardComponent {
  @Input({ required: true }) title = '';
  @Input({ required: true }) body = '';
  @Input() showGoToMaps = false;
  @Output() goToMaps = new EventEmitter<void>();
}
